export const getParamsToState = (
  params: URLSearchParams,
  searchParams: string[]
) => {
  const paramsToState: Record<string, any> = {};
  searchParams.forEach((param) => {
    const value = params.get(param);
    if (value) {
      paramsToState[param] = value;
      params.delete(param);
    }
  });
  return paramsToState;
};
